import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8v4","key":"svg-0"}],["path",{"d":"M12 16h.01","key":"svg-1"}]]

const IconAlertSmall = createReactComponent('outline', 'alert-small', 'AlertSmall', __iconNode);

export default IconAlertSmall;